module.exports = __webpack_public_path__ + "img/right.7e64759b.png";